/**
 * Filtra el menú declarativo (`navConfig`) contra el contexto de visibilidad.
 *
 * Función pura (sin React) para poder probar el gating con un objeto plano. Una
 * entrada sin predicado `visible` es incondicional; un grupo sin entradas
 * visibles se descarta entero (no se pinta su encabezado), igual que en el SSR,
 * donde el `{% if %}` del encabezado y el de sus enlaces van de la mano.
 */
import { NAV_SECTIONS } from "./navConfig";
import type { NavSection, NavVisibilityContext } from "./types";

export function filterNavSections(
  ctx: NavVisibilityContext,
  sections: NavSection[] = NAV_SECTIONS,
): NavSection[] {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) =>
        item.visible ? item.visible(ctx) : true,
      ),
    }))
    .filter((section) => section.items.length > 0);
}
